// app/not-found.tsx
'use client'
import { Box, Button, Typography } from '@mui/material'
import { useRouter } from 'next/navigation'

const NotFoundPage = () => {
  const router = useRouter()

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
    >
      <Typography variant="h5" gutterBottom>
        Oops! The page you’re looking for doesn’t exist
      </Typography>
      <Typography variant="h6" gutterBottom>
        Please let us know if you clicked a link to get here.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => router.push('/')}
        sx={{ mt: 4 }}
      >
        Go Back Home
      </Button>
    </Box>
  )
}

export default NotFoundPage
